<template>
    <div>
    <masternav/>
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('help.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('help.nav2')}}</span>
        </b-nav-item>
          <!-- <span class="mt-2 text-secondary">/</span>
        <b-nav-item >
          <span class="navtext">Another Link </span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item >
            <span class="navtext">Disabled </span>
        </b-nav-item> -->
      </b-nav>
      <div class="">
          <br>
        <h1 class="titlequestion ml-5 mr-5">{{$t('help.h1')}}</h1>
        <br><br>
        <div class="ml-5 mr-5">
        <p class="questions" v-b-toggle.collapse-q1>{{$t('help.h2')}}</p>
          <b-collapse id="collapse-q1" class="mt-2">
            <b-card>
                <li>{{$t('help.h3')}}</li>
                <li>{{$t('help.h4')}}</li>
                <li>{{$t('help.h5')}}</li>
                <li>{{$t('help.h6')}}</li>
                <li>{{$t('help.h7')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q3>{{$t('help.h8')}}</p>
        <b-collapse id="collapse-q3" class="mt-2">
            <b-card>
              <li>{{$t('help.h9')}}</li>
              <li>{{$t('help.h10')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q4>{{$t('help.h11')}}</p>
        <b-collapse id="collapse-q4" class="mt-2">
            <b-card>
              <li>{{$t('help.h12')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q5>{{$t('help.h13')}}</p>
        <b-collapse id="collapse-q5" class="mt-2">
            <b-card>
              <li>{{$t('help.h14')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q6>{{$t('help.h15')}}</p>
        <b-collapse id="collapse-q6" class="mt-2">
            <b-card>
              <li>{{$t('help.h16')}}</li>
              <li>{{$t('help.h17')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q7>{{$t('help.h18')}}</p>
        <b-collapse id="collapse-q7" class="mt-2">
            <b-card>
              <li>{{$t('help.h19')}}</li>
              <li>{{$t('help.h20')}}</li>
              <li>{{$t('help.h21')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q8>{{$t('help.h22')}}</p>
        <b-collapse id="collapse-q8" class="mt-2">
            <b-card>
              <li>{{$t('help.h23')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q9>{{$t('help.h24')}}</p>
        <b-collapse id="collapse-q9" class="mt-2">
            <b-card>
              <li>{{$t('help.h25')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q10>{{$t('help.h26')}}</p>
        <b-collapse id="collapse-q10" class="mt-2">
            <b-card>
              <li>{{$t('help.h27')}}</li>
              <li>{{$t('help.h28')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q11>{{$t('help.h29')}}</p>
        <b-collapse id="collapse-q11" class="mt-2">
            <b-card>
              <li>{{$t('help.h30')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q12>{{$t('help.h31')}}</p>
        <b-collapse id="collapse-q12" class="mt-2">
            <b-card>
              <li>{{$t('help.h32')}}</li>
            </b-card>
          </b-collapse>
        <p class="questions" v-b-toggle.collapse-q13>{{$t('help.h33')}}</p>
        <b-collapse id="collapse-q13" class="mt-2">
            <b-card>
              <li>{{$t('help.h34')}}</li>
            </b-card>
          </b-collapse>
        <br>
        </div>

        <!-- second questions -->
        <h3 class="titlequestion ml-5 mr-5">{{$t('help.h35')}}</h3>
        <br>
        <!--  -->
        <div class="ml-5 mr-5">
          <p class="questions" v-b-toggle.collapse-q14>{{$t('help.h36')}}</p>
          <b-collapse id="collapse-q14" class="mt-2">
            <b-card>
                <li>{{$t('help.h37')}}</li>
                <li>{{$t('help.h38')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q15>{{$t('help.h39')}}</p>
          <b-collapse id="collapse-q15" class="mt-2">
            <b-card>
                <li>{{$t('help.h40')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q16>{{$t('help.h41')}}</p>
          <b-collapse id="collapse-q16" class="mt-2">
            <b-card>
                <li>{{$t('help.h42')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q17>{{$t('help.h43')}}</p>
          <b-collapse id="collapse-q17" class="mt-2">
            <b-card>
                <li>{{$t('help.h44')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q18>{{$t('help.h45')}}</p>
          <b-collapse id="collapse-q18" class="mt-2">
            <b-card>
                <li>{{$t('help.h46')}}</li>
            </b-card>
          </b-collapse>
        </div>
        <br>
        <!-- third questions -->
        <h3 class="titlequestion ml-5 mr-5">{{$t('help.h47')}}</h3>
        <br>
        <!--  -->
        <div class="ml-5 mr-5">
          <p class="questions" v-b-toggle.collapse-q19>{{$t('help.h48')}}</p>
          <b-collapse id="collapse-q19" class="mt-2">
            <b-card>
                <li>{{$t('help.h49')}}</li>
                <li>{{$t('help.h50')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q20>{{$t('help.h51')}}</p>
          <b-collapse id="collapse-q20" class="mt-2">
            <b-card>
                <li>{{$t('help.h52')}}</li>
                <li>{{$t('help.h53')}}</li>
                <li>{{$t('help.h54')}}</li>
                <li>{{$t('help.h55')}}</li>
                <li>{{$t('help.h56')}}</li>
                <li>{{$t('help.h57')}}</li>
                <li>{{$t('help.h58')}}</li>
                <li>{{$t('help.h59')}}</li>
            </b-card>
          </b-collapse>
          <!--  -->
          <p class="questions" v-b-toggle.collapse-q21>{{$t('help.h60')}}</p>
          <b-collapse id="collapse-q21" class="mt-2">
            <b-card>
                <li>{{$t('help.h61')}}</li>
                <li>{{$t('help.h62')}}</li>
                <li>{{$t('help.h63')}}</li>
                <li>{{$t('help.h64')}}</li>
                <li>{{$t('help.h65')}}</li>
                <li>{{$t('help.h66')}}</li>
            </b-card>
          </b-collapse>
        </div>
        <br><br>
      </div>
    <mainfooter/>
    </div>
</template>
<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'

export default {
    name: 'Help',
    metaInfo: {
      title: "Enterprise Panama - Ayuda | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components:{
        masternav,
        mainfooter,
        maincontent,
        rents
    },
    data() {
      return {
        date: '',
        attributes: [
      {
        key: 'today',
        highlight: true,
        dates: new Date()
      }
    ]
  
      }
    },
}
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
</style>